import $ from "jquery";
import Cookies from 'js-cookie'

import { showAlert } from '../Shared/utils/alerts';


$(() => {
  $("#btn-save-changed-password").on("click", saveChangedPassword);
  $("#mdlg-change-password").on("hidden.bs.modal", handleCloseChangedPasswordForm);
  $("#mdlg-change-password").on("shown.bs.modal", handleShownChangedPasswordForm)
  $("#mdlg-change-password input[name='password']").on("input", clearErrorPassword);
  $("#mdlg-change-password input[name='new-password']").on("input", clearErrorNewPassword);
  $("#change-password a").on("click", showDlgChangePassword);
});

const showDlgChangePassword = (event) => {
  event.stopPropagation();
  var provider = Cookies.get('ExternalProvider');

  if (provider) {
    showAlert("#change-password .info", "alert-warning",
      `Вы используете для входа сторонний сервис - ${provider}. Если вы хотите изменить пароль, пожалуйста, используйте сайт сервиса.`,
      "mt-2"
    );
  } else {
    $("#mdlg-change-password").modal('show');
  }
};

const handleShownChangedPasswordForm = () => {
  $("#mdlg-change-password input[name='password']").focus();
};

const handleCloseChangedPasswordForm = () => {
  clearErrorPassword();
  clearErrorNewPassword();
  $("#mdlg-change-password input[name='password']").val("");
  $("#mdlg-change-password input[name='new-password']").val("");
};

const setErrorPassword = (error) => {
  $("#mdlg-change-password #password-valid-feedback").html(error);
  $("#mdlg-change-password input[name='password']").addClass("is-invalid");
};

const setErrorNewPassword = (error) => {
  $("#mdlg-change-password #new-password-valid-feedback").html(error);
  $("#mdlg-change-password input[name='new-password']").addClass("is-invalid");
};

const clearErrorPassword = () => {
  $("#mdlg-change-password #password-valid-feedback").html('');
  $("#mdlg-change-password input[name='password']").removeClass("is-invalid");
};

const clearErrorNewPassword = () => {
  $("#mdlg-change-password #new-password-valid-feedback").html('');
  $("#mdlg-change-password input[name='new-password']").removeClass("is-invalid");
};

const validateChangePasswordForm = () => {
  let result = true;

  const password = $("#mdlg-change-password input[name='password']").val();
  const newPassword = $("#mdlg-change-password input[name='new-password']").val();

  if (!password?.trim()) {
    setErrorPassword("Не указан текущий пароль");
    result = false;
  } else {
    clearErrorPassword();
  }

  if (!newPassword?.trim()) {
    setErrorNewPassword("Не указан новый пароль");
    result = false;
  } else {
    clearErrorNewPassword();
  }

  if (result && password === newPassword) {
    setErrorNewPassword("Новый пароль должен отличаться от старого");
    result = false;
  } else if (result) {
    clearErrorNewPassword();
  }

  return result;
};

const saveChangedPassword = (event) => {
  event.stopPropagation();

  if (!validateChangePasswordForm())
    return;

  const data = {
    password: $("#mdlg-change-password input[name='password']").val(),
    newPassword: $("#mdlg-change-password input[name='new-password']").val(),
    __RequestVerificationToken: $("#mdlg-change-password input[name='__RequestVerificationToken']").val()
  };

  $.ajax({
    url: "profile/change-password",
    type: "post",
    dataType: "html",
    data,
    cache: false,
    success: function () {
      $('#mdlg-change-password').modal('hide');
    },
    error: function (error) {
      if (error?.responseText) {
        const err = JSON.parse(error?.responseText);

        if (err?.password && err?.password[0]) {
          $("#mdlg-change-password #password-valid-feedback").html(err?.password[0]);
          $("#mdlg-change-password input[name='password']").addClass("is-invalid");
        }

        if (err?.newPassword && err?.newPassword[0]) {
          $("#mdlg-change-password #new-password-valid-feedback").html(err?.newPassword[0]);
          $("#mdlg-change-password input[name='new-password']").addClass("is-invalid");
        }

        if (err?.error && err?.error[0]) {
          $("#mdlg-change-password .error").html(err?.error[0]);
        }
      }
    }
  });
};